import React from 'react';
import { Link } from 'react-router-dom';

function trialEndDate() {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

export function RenewalConsent({ checked, onChange, tone = 'light' }) {
  const text = tone === 'dark' ? 'text-brand-cream/85' : 'text-brand-green/80';
  const box = tone === 'dark' ? 'bg-brand-cream/10 border-brand-cream/25' : 'bg-brand-cream/60 border-brand-cream-dark';
  return (
    <div data-testid="renewal-terms" className={`mt-4 rounded-lg border p-4 text-xs leading-relaxed ${box} ${text}`}>
      <p>
        <strong>Automatic renewal terms:</strong> You&apos;ll be charged <strong>$10 today</strong> for a 7-day trial.
        Unless you cancel before <strong>{trialEndDate()}</strong>, your subscription automatically renews at{' '}
        <strong>$100/month</strong> (plus tax), charged to your payment method every month until you cancel.
        Cancel anytime online in Billing &rarr; Manage subscription. Cancelling during the trial avoids the monthly charge;
        after that, cancellation takes effect at the end of the current billing period. See{' '}
        <Link to="/terms#s5" className="underline">Terms &sect;5</Link>.
      </p>
      <label className="mt-3 flex items-start gap-2 cursor-pointer">
        <input
          type="checkbox"
          data-testid="renewal-consent-checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 accent-brand-gold"
        />
        <span>I agree to the automatic renewal terms above.</span>
      </label>
    </div>
  );
}
